import { fetch } from '@atlassian/eoc-fetch';
export const getAlertDetail = alertId => fetch(`/v1/alerts/${alertId}`);
export const getAlertLogTypesEndpoint = () => fetch(`/v1/alerts/logs/types`);
export const getResponderStatesEndpoint = alertId => fetch(`/v1/alerts/${alertId}/responder-states`);
export const getEntityRelationTypesEndpoint = alertId => fetch(`/v1/alerts/${alertId}/entity-relations/relation-types`).then(res => ({
  relationTypes: res.relationTypes.sort((a, b) => a.label.localeCompare(b.label))
}));